import { render } from "./SessionExpiryIndicator.vue?vue&type=template&id=1651797a&scoped=true"
import script from "./SessionExpiryIndicator.vue?vue&type=script&lang=js"
export * from "./SessionExpiryIndicator.vue?vue&type=script&lang=js"

import "./SessionExpiryIndicator.css?vue&type=style&index=0&id=1651797a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1651797a"]])

export default __exports__